$(function () {
	var win = $(window);

	if ($('#uber').hasClass('interior')) {
		// Add class to uber if calendar template
		if ($('#CalendarTemplate').length > 0) {
			$('#uber').addClass('calendarView');
		}
	}

	win.on('load resize', function () {
		moveTheWidget();

		var sideWidgets = [
			'.promotionalCTA__container',
			'#contactMainContainer'
		];

		if (win.width() >= 992) {
			resetMoveSideWidgets(sideWidgets.reverse());
		} else {
			moveSideWidgets(sideWidgets);
		}
	});

	function moveTheWidget() {
		var widget = $('#schedulesWidget'),
			win = $(window);

		if (widget.length) {
			if (win.width() < 992) {
				if (widget.closest('#subNavWrapper').length || widget.index('#printArea > *') === 0) {
					widget.detach().appendTo('#printArea');
				}
			} else if (win.width() >= 992 && win.width() < 1600) {
				widget.detach().appendTo('#printArea');
			} else {
				widget.detach().prependTo('#subNavWrapper');
			}
		}
	}

	function moveSideWidgets(el) {
		if (el !== undefined || el !== null) {
			for (var i = 0; i < el.length; i++) {
				var me = el[i];

				if ($('#subNavWrapper').find(me).length) {
					$('#subNavWrapper').find(me).detach().appendTo('#printArea');
				}
			}
		}
	}

	function resetMoveSideWidgets(el) {
		if (el !== undefined || el !== null) {
			for (var i = 0; i < el.length; i++) {
				var me = el[i];

				if ($('#printArea').find(me).length) {
					if (me === '#contactMainContainer') {
						$('#printArea').find(me).detach().insertAfter('#subNavContainer');
					} else {
						$('#printArea').find(me).detach().prependTo('#subNavWrapper');
					}
				}
			}
		}
	}
});